import React from 'react';

import Target from '@Components/Results/targets/Target.jsx';
import ReactionComponent from '@Components/Results/reactions/reaction.component';
import DocumentComponent from '@Components/Results/documents/document.component';
import SubstanceComponent from '@Components/Results/substances/substance.component';
// Patent Family Clustering
// eslint-disable-next-line import/no-named-as-default
import PatentFamilyGroupContainer from '@Containers/PatentFamilyClustering/PatentFamilyGroupContainer';
// eslint-disable-next-line import/no-named-as-default
import SinglePatentFromFamilyContainer from '@Containers/PatentFamilyClustering/SinglePatentFromFamilyContainer';
import { isPatentFamilyGroup, isSinglePatentFromFamily } from '@Containers/PatentFamilyClustering/utils';

const renderers = {
  reactions: (result, props) => <ReactionComponent reaction={result} {...props} />,
  substances: (result, props) => <SubstanceComponent substance={result} {...props} />,
  tgitems: (result, props) => <Target target={result} {...props} />,
  citations: (result, props) => {
    const { metadata } = props;
    if (metadata.isViewPreview) {
      return <DocumentComponent document={result} {...props} />;
    }

    if (isPatentFamilyGroup(result)) {
      return <PatentFamilyGroupContainer document={result} {...props} />;
    }

    if (isSinglePatentFromFamily(result)) {
      return <SinglePatentFromFamilyContainer document={result} {...props} />;
    }

    return <DocumentComponent document={result} {...props} />;
  },
};

const ResultRenderer = {
  render(context, props) {
    const { result, ...rest } = props;
    const renderer = renderers[context];

    if (!renderer) throw new Error('Specified context is not yet implemented');
    if (!result) throw new Error('Invalid result param passed');

    return renderer(result, rest);
  },
};

export default ResultRenderer;
